<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="sensorData-modal">
<!-- <div class="modal-content sensorData-modal"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Sensor Readings from '{{ (sensor.name == '' || sensor.name == undefined) ? sensor.uuid : sensor.name }}'</h5>
        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div class="modal-body" style="padding: 0px;">

        <div *ngIf="!sensorDataAvailabilityIsLoaded" style="background-color: rgb(224, 224, 224); height: 30px; text-align: center; padding-top: 5px;">
            <button (click)="loadSensorDataAvailability()" class="btn btn-basic" type="button" style="font-size: 16px; margin-top: -10px; color: #5279bc">Load Sensor Readings Availability</button>
        </div>

        <div *ngIf="sensorDataAvailabilityIsLoaded" style="background-color: rgb(224, 224, 224); height: 100px; text-align: center; padding-top: 5px;">
            <label style="font-size: 16px; font-weight: 500;">Sensor Readings Availability</label>
            <figure  id="bar"></figure>
            <div *ngIf="!sensorDataAvailabilityReady" class="fa fa-spinner fa-spin fa-2x fa-fw" style="display: block; text-align: center; width: 100%;"></div>
        </div>

        <div style="text-align: center; padding-top: 5px;">
            <label style="font-size: 17px; font-weight: 500;">Data Views</label>
        </div>

        <div style="display:flex; gap: 20px; width: 1455px; margin-left: 20px; margin-right: 20px; margin-bottom: 20px;">
            <div style="width: 1100px; height: 655px;">
                <tabset>
                    <tab heading="Export" active="false">
                        <div style="display: flex;">
                            <div *ngIf="sensor.sensorReadingTypes != undefined && sensor.sensorReadingTypes.length > 0" style="margin: 20px; padding-left: 40px;">
                                <div style="text-align: center; margin-top: 10px; margin-bottom: 20px;">
                                    <label style="font-size: 17px; font-weight: 500;">Sensor Data Export</label>
                                </div>
                                <export-data-modal
                                    [sensor]="sensor"
                                    [selectedDateRange]="selectedDateRange"
                                    [selectedTimeZone]="selectedTimeZone"
                                    [selectedTimeZoneOffset]="selectedTimeZoneOffset"
                                    [includeOrigValues]="showOriginalReadings"
                                    [includeCalValues]="showCalibratedReadings" >
                                </export-data-modal>
                            </div>
                        </div>
                    </tab>

                    <tab heading="Map" active="false">
                        <google-map #googleMap
                            height="595px"
                            width="100%"
                            [zoom]="mapZoom"
                            [center]="mapCenter"
                            [options]="mapOptions">
                            <map-marker #marker="mapMarker"
                                *ngFor="let geoMapItem of geoMapItems"
                                [label]="geoMapItem.labelOptions"
                                [options]="{ icon: geoMapItem.icon }"
                                [position]="{ lat: geoMapItem.gpsLat, lng: geoMapItem.gpsLong }"
                                (mapClick)="common.openPinPopup(mapInfoWindow, marker, geoMapItem)">
                                <map-info-window #mapInfoWindow="mapInfoWindow" class="kig-pin-popup-host" (closeclick)="common.hidePinPopupLeader(geoMapItem)">
                                    <ng-container *ngTemplateOutlet="DisplayGeoPinInfo; context: { geoMapItem: geoMapItem }"></ng-container>
                                </map-info-window>
                            </map-marker>
                        </google-map>
                    </tab>

                    <tab heading="Table" active="false">
                        <p-table #sensorDataTable [columns]="sensorDataCols" [value]="sensorReadingInfosForPage" [scrollable]="true" scrollHeight="553px" pageLinks="15"
                                                    [lazy]="true" (onLazyLoad)="updateDataTable($event)" [paginator]="true" [rows]="14" totalRecords="{{sensorReadingInfosCount}}" [loading]="busyProcessing">
                            <ng-template let-columns pTemplate="header">
                                <tr style="height: 40px; margin-top: 1px;">
                                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                                        {{col.header}}
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template let-columns="columns" let-rowData ; pTemplate="body">
                                <tr style="height: 35px;">
                                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                        {{rowData.createdDate | date : 'medium'}}
                                    </td>
                                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                        {{rowData.tag}}
                                    </td>
                                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                        {{rowData.type}}
                                    </td>
                                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                        <div *ngIf="showOriginalReadings"> {{ rowData.origValue }} </div>
                                    </td>
                                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                        <div *ngIf="showCalibratedReadings"> {{ rowData.value }} </div>
                                    </td>
                                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px; text-align: center;">
                                        <i class="fa-solid fa-location-dot"
                                           [style.color]="common.readingGpsPinColor(rowData)"
                                           [title]="common.readingGpsPinTooltip(rowData)"></i>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </tab>

                    <tab heading="Chart" active="false">
                        <div style="padding: 10px; height: 630px;">
                            <chart-readings-echart-modal
                                [sensors]="echartSensors"
                                [sensorReadings]="echartReadings"
                                [sensorReadingTypes]="echartReadingTypes"
                                [includeCalValues]="showCalibratedReadings"
                                [includeOrigValues]="showOriginalReadings"
                                [darkBackground]="echartDarkBackground"
                                [showLegend]="false"
                                [showYAxisSlider]="true"
                                [fillHeight]="true">
                            </chart-readings-echart-modal>
                        </div>
                    </tab>
                </tabset>
            </div>

            <div style="width: 340px; padding-top: 5px; max-height: 655px;">
                <div class="form-group" style="font-size: 15px; margin-bottom: 8px;">
                    <label style="display: flex; align-items: center; gap: 8px; font-weight: 500;">
                        <p-toggleswitch [(ngModel)]="echartDarkBackground" name="EchartDarkBackground" [ngModelOptions]="{standalone: true}" (ngModelChange)="onEchartDarkBackgroundChange()"></p-toggleswitch>
                        Chart Dark Mode
                    </label>
                </div>
                <div class="form-group" style="font-size: 15px;">
                    <label for="UserGroup" style="font-weight: 500;">Displayed Timezone</label>
                    <div style="font-size: 14px; margin-top: 2px; margin-bottom: 10px;">
                        <input type="radio" [(ngModel)]="selectedTimeZone" name="Local" value="Local" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
                        <label style="padding-left: 5px; padding-right: 25px;;">Local</label>
                        <input type="radio" [(ngModel)]="selectedTimeZone" name="Source" value="Source" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
                        <label style="padding-left: 5px; padding-right: 25px;">Source</label>
                        <input type="radio" [(ngModel)]="selectedTimeZone" name="UTC" value="UTC" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
                        <label style="padding-left: 5px; padding-right: 25px;">UTC (GMT+0)</label>
                    </div>
                </div>
                <div class="form-group" style="font-size: 15px;">
                    <label for="UserGroup" style="font-weight: 500;">Readings</label>

                    <!-- GPS source indicator -->
                    <span style="margin-left: 8px;">
                        <i *ngIf="gpsSource === 'reading'"
                           class="fa-solid fa-location-dot"
                           style="color: #d32f2f;"
                           title="Using GPS from each reading"></i>

                        <i *ngIf="gpsSource === 'readings'"
                           class="fa-solid fa-location-dot"
                           style="color: #046dd6;"
                           title="GPS coordinates derived from latitude/longitude reading types"></i>

                        <i *ngIf="gpsSource === 'sensor'"
                           class="fa-solid fa-location-dot"
                           style="color: #2e7d32;"
                           title="Using GPS from the sensor's own location"></i>

                        <i *ngIf="gpsSource === 'none'"
                           class="fa-solid fa-location-dot"
                           style="color: #b0b0b0;"
                           title="No GPS coordinates available"></i>
                    </span>

                    <div style="font-size: 14px; margin-top: 4px; margin-bottom: 10px;">
                        <input type="checkbox" [(ngModel)]="showOriginalReadings" name="Original" value="showOriginalReadings" (ngModelChange)="selectedReadingSourceChanged()" style="cursor: pointer;"/>
                        <label style="padding-left: 5px; padding-right: 25px;;">Original Values</label>
                        <input type="checkbox" [(ngModel)]="showCalibratedReadings" name="Calibrated" value="showCalibratedReadings" (ngModelChange)="selectedReadingSourceChanged()" style="cursor: pointer;"/>
                        <label style="padding-left: 5px; padding-right: 25px;">Calibrated Values</label>
                    </div>
                </div>

                <div style="margin-bottom: 20px;">
                    <label for="UserGroup" style="font-weight: 500; margin-top: 3px;">Timespan:</label>
                    <button (click)="datesUpdated('Today')" class="btn btn-sm" style="color: rgb(0, 123, 255);" type="button">Today</button>
                    <button (click)="datesUpdated('Last 2 Days')" class="btn btn-sm" style="color: rgb(0, 123, 255);" type="button">Last 2 Days</button>
                    <button (click)="datesUpdated('Last 7 Days')" class="btn btn-sm" style="color: rgb(0, 123, 255);" type="button">Last 7</button>
                    <!-- <button (click)="datesUpdated('Last 30 Days')" class="btn btn-sm" style="color: rgb(0, 123, 255);" type="button">Last 30</button> -->
                    <input (datesUpdated)="datesUpdated('')" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                            [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                            ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width: 340px; font-size: medium;" />
                </div>

                <div style="border: 1px solid; border-color: lightgray; max-height: 430px; overflow-y: scroll;">
                    <p-table #readingTypesTable [columns]="sensorReadingTypeCols" [value]="sensor.sensorReadingTypes">

                        <ng-template let-columns pTemplate="header">
                          <tr style="height: 35px;">
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                <div *ngIf="col.field == 'checkbox'" (click)="toggleCheckedSensorReadingTypes()" style="padding-left: 4px; font-size: 20px;">▣</div>
                                {{col.header}}
                                <p-sortIcon *ngIf="col.header=='Reading Type'" [field]="col.field"></p-sortIcon>
                            </th>
                          </tr>
                        </ng-template>

                        <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                            <tr style="height: 35px;">
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                <p-checkbox
                                [(ngModel)]="rowData.checked" binary="true" id="{{rowData.id}}" name="{{rowData.id}}"
                                [ngModelOptions]="{standalone: true}"
                                (onChange)="sensorReadingSelectionChanged()">
                                </p-checkbox>
                            </td>
                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.type }}
                            </td>
                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.count }}
                            </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

    </div>
</div>


<!-- Info window shown when a GeoMap pin is clicked: the sensor, the visit's reading
     date, its readings, and a mini chart of the clicked reading type. Mirrors the
     shared map favorite (map-favorite.component.html), including the
     header colored from the pin's GPS-source color, and the drag-by-header with a
     leader line drawn on the map (by an OverlayView) back to the pin. -->
<ng-template #DisplayGeoPinInfo let-geoMapItem="geoMapItem">
  <div class="kig-pin-popup" cdkDrag
       [class.kig-pin-popup-detached]="geoMapItem.dragOffset?.x || geoMapItem.dragOffset?.y"
       [cdkDragRootElement]="geoMapItem.dragRootSelector"
       [cdkDragFreeDragPosition]="geoMapItem.dragOffset"
       (cdkDragStarted)="common.pinPopupDragStarted($event.source.getRootElement())"
       (cdkDragEnded)="common.updatePinPopupLeader(geoMapItem, $event.source.getFreeDragPosition(), map?.googleMap, $event.source.getRootElement())">
    <div class="kig-pin-popup-header" cdkDragHandle [style.color]="geoMapItem.headerColors?.bar">
        <h5 title="{{ geoMapItem.sensorRef }}">{{ geoMapItem.sensorRef }}</h5>
    </div>

    <div class="kig-pin-popup-body">
    <div style="margin-bottom: 10px;">
      <span style="color: #1c4966; margin-top: 10px;">Reading Date: </span>
      <span style="color: black; margin-top: 10px;">{{ geoMapItem.readingDate | date:'medium' }}</span>
    </div>

    <div style="max-height: 320px; overflow-y: auto;">
      <table width="255px;" style="margin-bottom: 0px;">
        <tr>
            <td width="62%" style="color: #1c4966;">
                Reading Type
            </td>
            <td width="38%" align="right" style="color: #1c4966;">
                Value
            </td>
        </tr>
      </table>

      <hr style="margin-top: 3px; margin-bottom: 3px; ">

      <table width="255px;" style="margin-bottom: 10px">
        <tr *ngFor="let reading of geoMapItem.readings | keyvalue; let i = index">
            <td width="62%" style="font-size: 14px;">
              <div *ngIf="geoMapItem.readingTypeCharted != reading.key" (click)="loadChartReadings(geoMapItem, reading.key)" style="cursor: pointer; color: #1c4966;">
                {{ reading.key }}
              </div>
              <div *ngIf="geoMapItem.readingTypeCharted == reading.key" (click)="loadChartReadings(geoMapItem, reading.key)" style="cursor: pointer; color: #ccc127;">
                {{ reading.key }}
              </div>
            </td>
            <td width="38%" style="font-size: 14px; text-align: right;">
                {{ reading.value }}
            </td>
        </tr>
      </table>
    </div>

    <!-- The mini chart only appears once the user clicks a reading type above. -->
    <div *ngIf="geoMapItem.chartData?.length > 0" style="padding: 0px; border: 1px solid lightgray; border-radius: 3px; background-color: white;">
      <ngx-charts-line-chart
          [view]="view"
          [scheme]="chartOptions.colorScheme"
          [results]="geoMapItem.chartData"
          [gradient]="chartOptions.gradient"
          [xAxis]="chartOptions.showXAxis"
          [yAxis]="chartOptions.showYAxis"
          [legend]="chartOptions.showLegend"
          [showXAxisLabel]="chartOptions.showXAxisLabel"
          [showYAxisLabel]="chartOptions.showYAxisLabel"
          [xAxisLabel]="chartOptions.xAxisLabel"
          [yAxisLabel]="chartOptions.yAxisLabel"
          [autoScale]="chartOptions.autoScale"
          [xAxisTickFormatting]="chartOptions.axisFormat"
          [legendTitle]="chartOptions.legendTitle"
          [timeline]="chartOptions.timeline"
          [yScaleMin]="chartOptions.scaleYMin"
          [yScaleMax]="chartOptions.scaleYMax">
      </ngx-charts-line-chart>
    </div>
    </div>
  </div>
</ng-template>
